import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Tooltip } from './tooltip.model';

export const DATASET_SCHEMA = Object.freeze({
  LABEL: '',
  DATA: List<number>([]),
  URLS: List<string>([]),
  TOOLTIPS: List<Tooltip>([]),
  BG_COLORS: List<string>([]),
});
const RECORD = generateSchema(DATASET_SCHEMA);
const KEYS: any = generateKeys(DATASET_SCHEMA);

export class Dataset extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TOOLTIPS,
        value: props.get(KEYS.TOOLTIPS)
          ? this.tooltips.map((params) => new Tooltip(params))
          : List<Tooltip>([]),
      },
    ]);

    return selfModel as Dataset;
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get data(): List<number> {
    return this.get(KEYS.DATA);
  }

  get urls(): List<string> {
    return this.get(KEYS.URLS);
  }

  get tooltips(): List<Tooltip> {
    return this.get(KEYS.TOOLTIPS);
  }

  get bgColors(): List<string> {
    return this.get(KEYS.BG_COLORS);
  }
}
